module.exports = __webpack_public_path__ + "static/media/arrow-left.251a964c.svg";